import { isTauri } from '@tauri-apps/api/core';
import type { Platform } from './types';
import { tauriPlatform } from './tauri';
import { webPlatform } from './web';

/** Chosen once, at startup. Never re-evaluated. */
export function createPlatform(): Platform {
  return isTauri() ? tauriPlatform : webPlatform;
}
